import { render } from "./ModalWork.vue?vue&type=template&id=2a4e1ad9"
import script from "./ModalWork.vue?vue&type=script&lang=js"
export * from "./ModalWork.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__